import { ResourceConfig } from '../types/resource'

/**
 * 过滤出需要访问权限的菜单项
 *
 * @param resources 菜单项
 * @returns 需要权限的菜单项
 */
export const filterRestrictedResources = (resources: ResourceConfig[]) => {
  return resources
    .map(
      (
        // 浅拷贝
        { ...item }
      ) => {
        // 如果没有子菜单，直接校验自身是否需要权限
        if (!item.children) {
          return item.uuid ? item : undefined
        }

        item.children = filterRestrictedResources(item.children)

        // 如果有需要访问权限的子菜单，那么自身也需要权限
        if (item.children.length > 0) {
          return item
        }

        // 如果没有需要访问权限的子菜单，那么自身是否需要权限
        return item.uuid ? item : undefined
      }
    )
    .filter(Boolean) as ResourceConfig[]
}
